import React from "react";

function Marrone() {
	return (
        <body className="Marrone">
        <iframe width="80%" height="80%" src="https://www.youtube.com/embed/cuJ9L5aBvio" title="432hz Deep Brown Noise in HD Stereo ( 12 Hours )" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" ></iframe>
        </body>	
	)
}

export default Marrone;



